
import type { SVGProps } from 'react';
const SvgAuctions = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="currentColor" viewBox="0 0 24 24" {...props}>
    <path
      fill="currentColor"
      d="m17.66 9.53-7.07-7.07a1 1 0 0 0-1.42 0L7.05 4.58a1 1 0 0 0 0 1.42l7.07 7.07a1 1 0 0 0 1.42 0l2.12-2.12a1 1 0 0 0 0-1.42M5.63 17.2 2.1 20.73a1 1 0 0 0 0 1.42 1 1 0 0 0 1.41 0l3.54-3.54zM20 18h-7a1 1 0 1 0 0 2h7a1 1 0 1 0 0-2"
    />
  </svg>
);
export default SvgAuctions;
